export default "<mat-icon class=\"back-icon\" (click)=\"overview()\">keyboard_backspace</mat-icon>\r\n"